import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import headshot from './architecture-bridge-canada-414462.jpg';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import {ThemeProvider } from '@material-ui/styles'

const styles = theme => ({


 rectangle: {

  webkitClipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
  position:'relative',
  color:'primary',
  width:'100%',
  margin:'5% 0 0 0',
  padding:'5% 0 5% 0',

  background:'white',
  },
  paper:{
    padding: theme.spacing(2),
    textAlign: 'center',
    align:'center',
  },
  headshot:{
    width:'80%',
  },
  teamDiv:
  {color:'white',
  background:'white',
  position:'relative',
  height:'80%',
  top:'5%',
  bottom:'0',
  }, 
  teamGridBottom:
  {
  margin:'5% 0 0 0',},
  teamGrid:
  {
  margin:'2% 0 0 0',},
   });

let theme = createMuiTheme({

});
theme = responsiveFontSizes(theme);
function Contact(props){
	const { classes } = props;
	return(
        
          <div className={classes.rectangle} color="primary">
                    	<ThemeProvider theme={theme}>

            <Grid container className={classes.teamGrid}>
              <Grid item xs={12}>
                <Typography variant="h2" align="center" color="textPrimary" gutterBottom>
				Connect with Us!
                </Typography>
              </Grid>
              <Grid item xs={false} sm={3} lg={4}/>
              <Grid item xs={12} sm={6} lg={4}>
                <Paper className={classes.paper}>
                <Typography variant="h5" align="center" color="textSecondary" paragraph>
                 Reach out to us and we'll have a conversation about how we can help make your business grow! 
                </Typography>
                <Typography varian="email" align="center" paragraph>
                <a href="mailto:info@triangulumstudios.com">info@triangulumstudios.com</a>
                </Typography>
                </Paper>
              </Grid>
              <Grid item xs={false} sm={3} lg={4}/>
             

            
            </Grid>
           </ThemeProvider>
          </div>

        );
}

export default withStyles(styles)(Contact);